import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  // { path: "/", redirect: "/index" },
  {
    path: "/",
    name: "index",
    component: () => import('@/views/index/index')
  },
  {
    path: "/index",
    name: "index",
    component: () => import('@/views/index/index')
  },
  {
    path: "/chatIndex",
    name: "chatIndex",
    component: () => import('@/views/chatIndex/chatIndex')
  },
  {
    path: "/login",
    name: "login",
    component: () => import('@/views/login/login')
  },
  {
    path: "/sign_up",
    name: "sign_up",
    component: () => import('@/views/sign_up/sign_up')
  },
  {
    path: "/forget",
    name: "forget",
    component: () => import('@/views/forget/forget')
  },
  {
    path: "/download",
    name: "download",
    component: () => import('@/views/download/download')
  },
  {
    path: "/searchCenter",
    name: "searchCenter",
    component: () => import('@/views/searchCenter/searchCenter')
  },
  {
    path: "/ewmInfo",
    name: "ewmInfo",
    component: () => import('@/views/ewmInfo/ewmInfo')
  }
  
  
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

export default router
